import React from "react";
import './section-view.scss';


class SectionView extends React.Component {


    render() {
        return(
            <div>
                Test
            </div>
        )
    }

}

export default SectionView;